import {
  SubmitHandler,
  useController,
  useForm,
  useWatch
} from 'react-hook-form'
import { KeyCloakRealm } from '@tecsinapse-org/keycloak-unified-authentication'
import { getKeycloak } from '@/core/data/keycloak'
import { IPreLogin } from '@/modules/pre-login/types'
import { setAndRedirect } from '@/modules/pre-login/utils/functions'

const usePreLogin = () => {
  const { handleSubmit, register, formState, setValue, control, setError } =
    useForm<IPreLogin>()
  const { field } = useController({ name: 'current', control })
  const realmsWatcher = useWatch({ control, name: 'realms' })

  const _onSubmit: SubmitHandler<IPreLogin> = async ({
    email,
    current,
    realms
  }) => {
    try {
      if (realms && current) {
        setAndRedirect(
          realms.find(e => e.realm === current.realm) as KeyCloakRealm
        )
        return
      }
      const fetched = await getKeycloak(email.trim())
      if (fetched.length === 0) {
        setError('email', {
          message: 'Nenhuma correspondência encontrada :('
        })
        return
      }
      if (fetched.length > 1) {
        setValue('realms', fetched)
        // Message only set to block form
        setError('current', { message: 'Selecione o cliente' })
        return
      }
      setAndRedirect(fetched[0])
    } catch (error) {
      console.error(error)
      setError('email', {
        message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.'
      })
    }
  }

  return {
    realmsWatcher,
    onSubmit: handleSubmit(_onSubmit),
    field,
    register,
    formState
  }
}

export default usePreLogin
